<div class="tabs-bg">
  <div class="tabs">
    <button class="tab" [class.active]="selected() === 'all'" (click)="setSelected('all')">
      <span class="chip" [class.active]="selected() === 'all'">
        <span class="label" [class.active]="selected() === 'all'">All ({{ allCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'load'" (click)="setSelected('load')">
      <span class="chip" [class.active]="selected() === 'load'">
        <span class="label" [class.active]="selected() === 'load'">Load ({{ loadCount }})</span>
      </span>
    </button>
    <button *ngIf="showShuntingTab" class="tab" [class.active]="selected() === 'shunting'" (click)="setSelected('shunting')">
      <span class="chip" [class.active]="selected() === 'shunting'">
        <span class="label" [class.active]="selected() === 'shunting'">Shunting ({{ shuntingCount }})</span>
      </span>
    </button>
    <button class="tab" [class.active]="selected() === 'transloading'" (click)="setSelected('transloading')">
      <span class="chip" [class.active]="selected() === 'transloading'">
        <span class="label" [class.active]="selected() === 'transloading'">Transloading ({{ transloadingCount }})</span>
      </span>
    </button>
    <button *ngIf="showTransferredTab" class="tab" [class.active]="selected() === 'transferred'" (click)="setSelected('transferred')">
      <span class="chip" [class.active]="selected() === 'transferred'">
        <span class="label" [class.active]="selected() === 'transferred'">Transferred ({{ transferredCount }})</span>
      </span>
    </button>
  </div>
</div>